import { api } from '@/scripts/api';

export const SocialMediaConnectService = {
    get(clientId, socialMedia){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/connect/auth/${clientId}?accountType=${socialMedia}`;

            api.get(service)
            .then(resolve)
            .catch(reject);
        });
    },
}
